<div class="range-slider__wrapper">
    <mat-slider
            class="range-slider"
            [disabled]="disabled"
            [max]="max"
            [min]="min"
            [step]="step"
            [value]="value"
            (valueChange)="onChangeValue($event)"
    ></mat-slider>
    <span class="range-slider__value">{{value || 0}}%</span>
</div>
